import { render, staticRenderFns } from "./ReusePotentialIndex.vue?vue&type=template&id=2aa9abd4&scoped=true"
import script from "./ReusePotentialIndex.vue?vue&type=script&lang=js"
export * from "./ReusePotentialIndex.vue?vue&type=script&lang=js"
import style0 from "./ReusePotentialIndex.vue?vue&type=style&index=0&id=2aa9abd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa9abd4",
  null
  
)

export default component.exports